import { render } from "./SoftButton.vue?vue&type=template&id=22fbf2f4&scoped=true"
import script from "./SoftButton.vue?vue&type=script&lang=js"
export * from "./SoftButton.vue?vue&type=script&lang=js"

import "./SoftButton.vue?vue&type=style&index=0&id=22fbf2f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fbf2f4"]])

export default __exports__